import React, { useState, useEffect, useMemo, useContext } from 'react';
import axios from 'axios';
import { Container, Card, Text, Button } from '../../design-system';
import { isEmpty, find } from 'lodash';
import { Block } from '../../design-system';
import {
  useToggle,
  useDeepCompareEffect,
  useLocation,
  useUpdateEffect,
} from 'react-use';
import { useData } from '../../helpers/data-loader';
import {
  errorMsg,
  checkPermissions,
  createSelectOptions,
} from '../../helpers/utils';
import ContainerHeader from '../../components/ContainerHeader';
import { Table } from '../../components/Table';
import { ERR_MSG, PERMISSIONS, US_STATES } from '../../globalConstants';
import {
  US_CITIES,
  FOUNDATION_COLUMNS,
  MAJOR_FUNDING_CATEGORIES,
} from './constants';
import { Session } from '../../contexts/sessionContext';
import { ACTIVE_OPTIONS, nameFromArray } from '../shared-constants';
import OrgSearchTableFilter from '../../components/OrgSearchTableFilter';
import { OrgSearchContext, ACTIONS } from '../../contexts/orgsearchContext';
import Alert from '../../helpers/alert';
import { DeadlinesContext } from '../../contexts/deadlinesContext';

const OrgSearch = () => {
  const location = useLocation();

  const {
    state: {
      user: { permissions, isClient },
    },
  } = useContext(Session);
  const {
    state: { search, filters },
    dispatch,
  } = useContext(OrgSearchContext);

  const [filterParams, setFetchParams] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [isOpen, toggleOpen] = useToggle(false);

  const [isDownloading, toggleIsDownloading] = useToggle(false);

  const [orgData, fetchOrgData, loadingActions] = useData(
    '/organizations/lookup',
    {
      errorMsg: errorMsg('organizations'),
    },
  );

  const getFilterFields = () => {
    return null;
  };
  const filtersToDisplay = useMemo(() => {
    return Object.entries(filters)
      .filter(([filter, value]) => {
        if (!value) {
          return false;
        }

        return true;
      })
      .map(([filter, value]) => {
        const displayValue = value;

        return { filter, displayValue };
      });
  }, [filters]);

  const makeReq = () => {
    console.log(filters);
    console.log(filterParams);

    fetchOrgData({
      params: { ...filterParams, ...filters, search: searchValue },
    });
  };

  useUpdateEffect(() => {
    makeReq();
  }, [filterParams, searchValue, filters]);

  const clearFilters = () => {
    dispatch({ type: ACTIONS.CLEAR_FILTERS });
  };

  const saveFilters = (values: any) => {
    dispatch({ type: ACTIONS.SET_FILTERS, value: values });
  };

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const handlePageChange = ({
    pageIndex,
    pageSize,
    sortColumn,
    sortDesc,
  }: {
    pageIndex: number;
    pageSize: number;
    sortColumn: any;
    sortDesc: any;
  }) => {
    setFetchParams((prevState) => ({
      ...prevState,
      page: pageIndex + 1,
      page_size: pageSize,
      sortColumn,
      sortDesc,
    }));
    console.log(`page change ${pageIndex}`);
  };

  const lackPermission = () => {
    Alert.error(
      'You are an external user and do not have permission to export data. Please contact the software administrator to generate this report for you.',
    );
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const preset = Object.fromEntries(params.entries());
    saveFilters({ ...filters, ...preset });
  }, []);

  return (
    <Container fluid gutter={50}>
      <Card mt={30}>
        <ContainerHeader>
          <Text fontSize={25}>Foundation Search</Text>
        </ContainerHeader>
        <Block mb={3}>
          <OrgSearchTableFilter
            search={search}
            handleSearch={handleSearch}
            clearFilters={clearFilters}
            filtersToDisplay={filtersToDisplay}
            filters={filters}
            saveFilters={saveFilters}
            isOpen={isOpen}
          />
        </Block>

        <Table
          onPageChange={handlePageChange}
          columns={FOUNDATION_COLUMNS}
          data={orgData}
          loading={loadingActions}
          pagination={true}
        />
      </Card>
    </Container>
  );
};

export default OrgSearch;
